import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Location} from '@angular/common';

@Component({
  selector: 'app-regisproduct',
  templateUrl: './regisproduct.component.html',
  styleUrls: ['./regisproduct.component.css']
})
export class RegisproductComponent implements OnInit {

  constructor(
    private route:ActivatedRoute,
		public contentService:ApiContentService,
    private fb: FormBuilder,  
    private router: Router,
    private _location: Location
  ) { }

  // registerForm: FormGroup;
  submitted = false;
  prospekindex = '';
  loadingIcon = {
    invalid: false
  };
  regis:any = [];
  fileData: File = null;
  previewUrl:any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  family:any = [];
  onfamily = false;
  onalacarte = false;

  data_product_iptv:any = []
  data_product_hsi:any = []
  data_alacarte: any = []
  data_table_alacarte: any = []

  product:any = {}
  alacarte:any = {};
  form:any = {
    formPtype: true,
    formIptv: false,
    chooseIptv: false,
    formHsi: false,
    chooseHsi: false,
    labelhsi: false,
    labelPricehsi: false,
    formAlacarte: false,
    chooseAlacarte: false,
    // labelAlacarte: false,
    labelPricealacarte: false
  }
  total:number = 0

  ngOnInit(): void {
    this.prospekindex = this.route.snapshot.params.prospekindex
    this.checkProspek(this.prospekindex);
    
    // this.registerForm = this.fb.group({
    //   idref: [''],
    // });
    this.clearAll()
    this.choosePtype(2)//product bundling
  }

  clearAll(){
    this.total = 0
    this.product = {}
    this.alacarte = {}
    this.form = {
      formPtype: true,
      formIptv: false,
      chooseIptv: false,
      formHsi: false,
      chooseHsi: false,
      labelhsi: false,
      labelPricehsi: false,
      formPrice: false,
      formAlacarte: false,
      chooseAlacarte: false,
      // labelAlacarte: false,
      labelPricealacarte: false
    }

    this.data_product_iptv = []
    this.data_product_hsi = []
    this.data_alacarte = []
    this.data_table_alacarte = []
  }

  // untuk validasi di form
  // get f(){
  //   return this.registerForm.controls;
  // }

  checkProspek(prospekindex:any){
    // console.log(prospekindex);
    const params = {
      'prospekindex' : prospekindex
    }
    this.contentService.checkProspek(params).subscribe((response:any) => {
      if (response.status) {
        this.loadingIcon.invalid = false;

        // this.regis = response.data;
        // this.listProductiptv()

      }else{
        this.loadingIcon.invalid = true;
      }
    });
  }

  choosePtype(pt:any){
    this.product.product_type_name = (pt == 2 ? "Bundling" : "Internet Only")
    this.product.product_type = pt
    this.form.formPtype = false
    
    if( pt == 2 ){
      this.form.formIptv = true
      this.form.chooseIptv = true
      this.listProductiptv()
    }else{
      this.form.formHsi = true
      this.form.labelhsi = true
      this.form.chooseHsi = true
      this.form.labelPricehsi = false
      this.form.formAlacarte = false
      this.form.chooseAlacarte = false
      // this.form.labelAlacarte = false
      this.form.labelPricealacarte = false
      this.listProducthsi()
    }
  }
  choosePiptv(dataIptv:any){
    this.product.iptv_name = dataIptv.iptv_name
    this.product.iptv_id = dataIptv.iptv_id
    this.form.chooseIptv = false
    this.form.formHsi = true
    this.form.labelhsi = true
    this.form.chooseHsi = true
    this.listProducthsi()
  }
  choosePhsi(dataHsi:any){
    
    this.product.hsi_name = dataHsi.hsi_name
    this.product.hsi_id = dataHsi.hsi_id
    this.product.product_id = dataHsi.product_id
    this.product.price = dataHsi.price
    this.total = this.product.price

    if ( this.product.product_id === 2347 || this.product.product_id === 2335) {
      this.form.chooseHsi = false
      this.form.labelhsi = false
      this.form.labelPricehsi = true
      this.form.formAlacarte = true
      this.form.chooseAlacarte = true
      this.form.labelAlacarte = true
      this.form.formPrice = true
      // this.form.labelPricealacarte = true
      this.listProductalacarte()
    } else {
      this.form.labelhsi = false
      this.form.formHsi = true
      this.form.labelPricehsi = true
      this.form.chooseHsi = false
      this.form.formAlacarte = false
      this.form.chooseAlacarte = false
      // this.form.labelAlacarte = true
      this.form.labelPricealacarte = false
      this.form.formPrice = true
    }    

    console.log(this.product)
  }
  choosePalacarte(dataAlacarte:any){

    this.data_table_alacarte.push(
      {
        'iptv_name': dataAlacarte.iptv_name,
        'iptv_id': dataAlacarte.iptv_id,
        'product_id': dataAlacarte.product_id,
        'price': dataAlacarte.price
      }
    )

    this.data_table_alacarte.forEach(element => {
      this.total = this.product.price + element.price
      // console.log('masuk',element, this.data_product_hsi, this.total)
    })

    // reduce untuk Mengakumulasikan atau mengurangi nilai berdasarkan elemen di dalam array.
    this.data_table_alacarte.reduce( (previousValue, currentValue) => {
      this.total = this.product.price + previousValue.price + currentValue.price
      // console.log('coba',this.total)
    })
    this.form.labelAlacarte = false
    this.form.formAlacarte = true
    this.form.labelPricealacarte = true
    this.form.chooseAlacarte = true
    this.form.formPrice = true
    // this.price = this.product.product_id === 2347 || this.product.product_id === 2335 ? this.alacarte.price_alacarte :  this.product.price
    // this.product.price = this.price + this.alacarte.price_alacarte
    // console.log(this.price + this.product.price_alacarte)
    console.log(this.data_table_alacarte)
  }  

  listProductiptv() {
    const params = {}
    params['channel_type'] = 2
    params['customer_type'] = 1
    params['product_type'] = this.product.product_type
    let datapost = params
    
    // const data = {
    //   "search" : this.formProduct.value.search,
    // }

    this.contentService.listProductiptvsgs(datapost)
      .subscribe((response: any) => {
        this.data_product_iptv = response.data
        console.log(response);
      }
    );
  }
  
  listProducthsi() {
    const params = {}
    params['channel_type'] = 2
    params['customer_type'] = 1
    params['product_type'] = this.product.product_type

    if ( this.product.product_type == 2 ) {
      params['iptv_id'] = this.product.iptv_id
    }

    let datapost = params
    
    // const data = {
    //   "search" : this.formProduct.value.search,
    // }

    this.contentService.listProducthsisgs(datapost)
      .subscribe((response: any) => {
        this.data_product_hsi = response.data
        console.log(response);
      }
    );
  }

  listProductalacarte() {
    const params = {}
    params['channel_type'] = 2
    params['product_id'] = this.product.product_id

    let datapost = params
    
    // const data = {
    //   "search" : this.formProduct.value.search,
    // }

    this.contentService.listProductalacartesgs(datapost)
      .subscribe((response: any) => {
        console.log(response);
        this.data_alacarte = response.data
      }
    );
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    // Show preview 
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.fileData); 
    reader.onload = (_event) => { 
      this.previewUrl = reader.result; 
    }
  }

  onNext(){
    const params = {}
    params['prospekindex'] = this.prospekindex
    params['main'] = this.product
    params['alacarte'] = this.data_table_alacarte
    params['price'] = this.total

    let datapost = params
    // console.log(this.data_table_alacarte)

    this.contentService.setProspekorder(datapost)
      .subscribe((response: any) => {
        console.log(response)
        if ( response.status ) {
          alert(response.message)
          this.router.navigate(['regis4/', this.prospekindex]);
        }else{

        }
      }
    );

  }

  backClicked() {
    this.router.navigate(['regis2/', this.prospekindex]);
  }

  onReset(){
    this.submitted = false;
    // this.registerForm.reset();
  }

  onFamily(){
    // console.log("masuk");    
    this.contentService.getProduct().subscribe((response:any) => {
      
      if (response.status == true) {

        this.onfamily = true;

        this.family = response.data.data;
        console.log(this.family);

      }
    });   
    
  }

  onAlacarte(params:any){
    this.contentService.getAlacarte(params).subscribe((response: any) => {
      this.onalacarte = true;
      
      this.alacarte = response.data;
      console.log(this.alacarte);
    });
  }

  onInet(){

  }

}
